module.exports = __webpack_public_path__ + "static/img/2735802953d4aa4bb3a86e2b92245573.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Download-2.png
// module id = LoB0
// module chunks = 1